import CustomFormat from '@/helpers/custom-format'

export default {
  filtro: {
    status: function (perfilList, selecionado) {
      if (!selecionado || selecionado.ativo == null || selecionado == '') {
        return perfilList;
      } else {
        return perfilList.filter(perfil => perfil.ativo == selecionado.ativo);
      }
    },
    busca: function (perfilList, pesquisa) {
      if (!pesquisa || pesquisa == '') {
        return perfilList;
      } else {
        return perfilList.filter(perfil => CustomFormat.removerAcentos(perfil.descricao).includes(CustomFormat.removerAcentos(pesquisa)));
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/perfil/functions.js